import { i as inject } from "../services/current-app-832a37a5.mjs";
import { V as VaAppCachePluginKey } from "../services/cache/plugin/index-d7f76192.mjs";
const useCache = () => {
  const cache = inject(VaAppCachePluginKey);
  if (!cache) {
    throw new Error("Vuestic cache plugin is not registered!");
  }
  return cache;
};
export {
  useCache as u
};
//# sourceMappingURL=useCache-8f053ac4.mjs.map
